import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { RoutesEnum } from '~/constants/enums';
import { useGetUserProfileQuery } from '~/redux/api/authApiSlice';

const RequireAuth = ({ children }: { children: React.ReactNode }) => {
  const { i18n } = useTranslation();
  const locale = i18n.language;
  const { isLoading, isSuccess } = useGetUserProfileQuery();

  useEffect(() => {
    if (!isLoading && !isSuccess) {
      window.location.replace(
        `${process.env.REACT_APP_BASE_URL}/${locale}/${RoutesEnum.LOGIN}`,
      );
    }
  }, [isLoading, isSuccess, locale]);

  if (isLoading || !isSuccess) {
    return (
      <div className="h-screen w-full flex justify-center items-center">
        <span className="loading loading-spinner loading-lg bg-blue"></span>
      </div>
    );
  }

  return <>{children}</>;
};

export default RequireAuth;
